import { watch } from 'vue';

const SEO_KEY_BY_ROUTE = {
  home: 'home',
  galery: 'gallery',
  contact: 'contact'
};

const SITE_URL = 'https://apartman-sentic.com';

function setMeta(attr, key, content) {
  let el = document.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute('content', content);
}

function setCanonical(href) {
  let el = document.querySelector('link[rel="canonical"]');
  if (!el) {
    el = document.createElement('link');
    el.setAttribute('rel', 'canonical');
    document.head.appendChild(el);
  }
  el.setAttribute('href', href);
}

export function initSeo(router, i18n) {
  const apply = () => {
    const route = router.currentRoute.value;
    const seoKey = SEO_KEY_BY_ROUTE[route.name] || 'home';
    const t = i18n.global.t;

    const title = t(`seo.${seoKey}.title`);
    const description = t(`seo.${seoKey}.description`);
    const canonicalUrl = `${SITE_URL}${route.path === '/' ? '' : route.path}`;

    document.title = title;
    document.documentElement.lang = i18n.global.locale.value;

    setMeta('name', 'description', description);
    setMeta('property', 'og:title', title);
    setMeta('property', 'og:description', description);
    setMeta('property', 'og:url', canonicalUrl);
    setCanonical(canonicalUrl);
  };

  watch(() => [router.currentRoute.value.fullPath, i18n.global.locale.value], apply, { immediate: true });
}
